/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const echo = `query Echo($msg: String) {
  echo(msg: $msg)
}
`;
export const listPlans = `query ListPlans {
  listPlans
}
`;
export const getCheckoutSession = `query GetCheckoutSession($id: String!) {
  getCheckoutSession(id: $id)
}
`;
export const getCustomer = `query GetCustomer($id: String!) {
  getCustomer(id: $id)
}
`;
export const getSubscription = `query GetSubscription($id: String!) {
  getSubscription(id: $id)
}
`;
export const getUserdata = `query GetUserdata($id: ID!) {
  getUserdata(id: $id) {
    id
    fullname
    avv_link
    avv_version
    avv_signature
    avv_signed_date
    createdAt
    updatedAt
  }
}
`;
export const listUserdatas = `query ListUserdatas(
  $filter: ModelUserdataFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserdatas(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      fullname
      avv_link
      avv_version
      avv_signature
      avv_signed_date
      createdAt
      updatedAt
    }
    nextToken
  }
}
`;
export const getCompany = `query GetCompany($id: ID!) {
  getCompany(id: $id) {
    id
    name
    fullname
    address_street
    address_street_no
    address_zip
    address_city
    address_country
    responsible_name
    responsible_role
    processes {
      nextToken
    }
    measureSets {
      nextToken
    }
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
export const listCompanys = `query ListCompanys(
  $filter: ModelCompanyFilterInput
  $limit: Int
  $nextToken: String
) {
  listCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      fullname
      address_street
      address_street_no
      address_zip
      address_city
      address_country
      responsible_name
      responsible_role
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    nextToken
  }
}
`;
export const getMeasureSetMeasure = `query GetMeasureSetMeasure($id: ID!) {
  getMeasureSetMeasure(id: $id) {
    id
    label
    description
    measureSet {
      id
      type
      label
      seq_nr
      description
      commentatory
      status
      createdAt
      updatedAt
    }
    status
    createdAt
    updatedAt
  }
}
`;
export const listMeasureSetMeasures = `query ListMeasureSetMeasures(
  $filter: ModelMeasureSetMeasureFilterInput
  $limit: Int
  $nextToken: String
) {
  listMeasureSetMeasures(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      label
      description
      status
      createdAt
      updatedAt
    }
    nextToken
  }
}
`;
export const getProcessMeasure = `query GetProcessMeasure($id: ID!) {
  getProcessMeasure(id: $id) {
    id
    auto_managed
    label
    description
    process {
      id
      text_header
      seq_nr
      status
      text_legal
      legal_basis
      text_problem
      damage_scenario
      risk_probability
      data_category
      victim_risk
      damage_rate
      dept_resp
      recipient_category
      delete_period
      assessment_necessary
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    status
    createdAt
    updatedAt
  }
}
`;
export const listProcessMeasures = `query ListProcessMeasures(
  $filter: ModelProcessMeasureFilterInput
  $limit: Int
  $nextToken: String
) {
  listProcessMeasures(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      auto_managed
      label
      description
      status
      createdAt
      updatedAt
    }
    nextToken
  }
}
`;
export const getMeasureSet = `query GetMeasureSet($id: ID!) {
  getMeasureSet(id: $id) {
    id
    company {
      id
      name
      fullname
      address_street
      address_street_no
      address_zip
      address_city
      address_country
      responsible_name
      responsible_role
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    type
    label
    seq_nr
    description
    processes {
      nextToken
    }
    measures {
      nextToken
    }
    commentatory
    status
    createdAt
    updatedAt
  }
}
`;
export const listMeasureSets = `query ListMeasureSets(
  $filter: ModelMeasureSetFilterInput
  $limit: Int
  $nextToken: String
) {
  listMeasureSets(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      label
      seq_nr
      description
      commentatory
      status
      createdAt
      updatedAt
    }
    nextToken
  }
}
`;
export const getProcessMeasureSet = `query GetProcessMeasureSet($id: ID!) {
  getProcessMeasureSet(id: $id) {
    id
    process {
      id
      text_header
      seq_nr
      status
      text_legal
      legal_basis
      text_problem
      damage_scenario
      risk_probability
      data_category
      victim_risk
      damage_rate
      dept_resp
      recipient_category
      delete_period
      assessment_necessary
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    measureSet {
      id
      type
      label
      seq_nr
      description
      commentatory
      status
      createdAt
      updatedAt
    }
    status
  }
}
`;
export const listProcessMeasureSets = `query ListProcessMeasureSets(
  $filter: ModelProcessMeasureSetFilterInput
  $limit: Int
  $nextToken: String
) {
  listProcessMeasureSets(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
    }
    nextToken
  }
}
`;
export const getProcess = `query GetProcess($id: ID!) {
  getProcess(id: $id) {
    id
    company {
      id
      name
      fullname
      address_street
      address_street_no
      address_zip
      address_city
      address_country
      responsible_name
      responsible_role
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    comments {
      nextToken
    }
    text_header
    seq_nr
    status
    text_legal
    legal_basis
    text_problem
    damage_scenario
    risk_probability
    data_category
    victim_risk
    damage_rate
    dept_resp
    recipient_category
    delete_period
    assessment_necessary
    measureSets {
      nextToken
    }
    measures {
      nextToken
    }
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
export const listProcesss = `query ListProcesss(
  $filter: ModelProcessFilterInput
  $limit: Int
  $nextToken: String
) {
  listProcesss(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      text_header
      seq_nr
      status
      text_legal
      legal_basis
      text_problem
      damage_scenario
      risk_probability
      data_category
      victim_risk
      damage_rate
      dept_resp
      recipient_category
      delete_period
      assessment_necessary
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    nextToken
  }
}
`;
export const getProcComment = `query GetProcComment($id: ID!) {
  getProcComment(id: $id) {
    id
    process {
      id
      text_header
      seq_nr
      status
      text_legal
      legal_basis
      text_problem
      damage_scenario
      risk_probability
      data_category
      victim_risk
      damage_rate
      dept_resp
      recipient_category
      delete_period
      assessment_necessary
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    text
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
export const listProcComments = `query ListProcComments(
  $filter: ModelProcCommentFilterInput
  $limit: Int
  $nextToken: String
) {
  listProcComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      text
      createdAt
      updatedAt
      archived_at
      deleted_at
    }
    nextToken
  }
}
`;
